// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $translate,
    $uibModal,
    Alert,
    DropboxProvisioningService,
) {
    this.$onInit = () => {
    const companyId = $state.params.companyId;
    const appId = $state.params.appId;
    
    $scope.useKeyAndSecret = true;
   

    $scope.application = this.application;
    $scope.autoSyncOptionsDetails=[];
    $scope.userProvisioningEnabled = false;
    $scope.boolFlag={autoSyncEnabled : false};
    var  provisioningBackupConfiguration;
    $scope.displayedDropboxSyncMappings =[];
            const data = this.dropboxConfigurationDTO;
            provisioningBackupConfiguration = angular.copy(data.dropboxConfiguration);
            $scope.basicProvisioningConfiguration = angular.copy(data.dropboxConfiguration)
            $scope.smartProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
            $scope.smartSyncConfiguration = angular.copy(data.dropboxConfiguration);
            $scope.accountSettingOptions=data.accountSettingOptions;
            $scope.groupSettingOptions=data.groupSettingOptions;
            $scope.adAttributeOptions=data.adAttributeOptions;
            $scope.autoSyncOptions = data.autoSyncOptions;
            setSyncSettingData() ;
            setNewTablesData(data);
            if($scope.basicProvisioningConfiguration.accessToken!=null) {
                $scope.useKeyAndSecret=false;
            }

    $scope.enableDisableAutoSync= function(newValue){
       if(! newValue) {
           angular.forEach($scope.autoSyncOptionsDetails,function(item){ item.detail = null; });
           $scope.smartSyncConfiguration.autoSyncSetting='NO_AUTOSYNC';
       }
    }
    function setSyncSettingData() {
        $scope.autoSyncOptionsDetails=[];
        angular.forEach($scope.autoSyncOptions, function(value,index) {
            var option={ option:value , detail: null};
            if(value==provisioningBackupConfiguration.autoSyncSetting) {
                option.detail=Number(angular.copy(provisioningBackupConfiguration.autoSyncTimeValue));
            }
            $scope.autoSyncOptionsDetails.push(option);
        });
        $scope.boolFlag.autoSyncEnabled = provisioningBackupConfiguration.autoSyncSetting!='NO_AUTOSYNC';
       
    }
    $scope.syncNow = function () {
        $scope.loadingMessage=$translate.instant('dropbox_provisioning.sync_process_progress');
        $('#loadingModal').modal('show');
        DropboxProvisioningService.syncNow.get({
               companyId : companyId,
            appId : appId
        }).$promise.then(function(data) {
            provisioningBackupConfiguration = angular.copy(data.dropboxConfiguration);
            $scope.basicProvisioningConfiguration = angular.copy(data.dropboxConfiguration)
            $scope.smartProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
            $scope.setNewTablesData(data);
            $('#loadingModal').modal('hide');
            Alert('success', 'dropbox_provisioning.successful_sync');
         }, function(error) {
             $('#loadingModal').modal('hide');
        });
        
    }
    
    $scope.provNow = function () {
        $scope.loadingMessage=$translate.instant('dropbox_provisioning.prov_process_progress');
        $('#loadingModal').modal('show');
        DropboxProvisioningService.provisionNow.get({
               companyId : companyId,
            appId : appId
        }).$promise.then(function(data) {
            $('#loadingModal').modal('hide');
            $scope.setNewTablesData(data);
            Alert('success', 'dropbox_provisioning.successful_prov');
         }, function(error) {
             $('#loadingModal').modal('hide');
        });
        
    }
    
    $scope.automap = function () {
        $('#loadingModal').modal('show');
        DropboxProvisioningService.automap.get({
               companyId : companyId,
            appId : appId
        }).$promise.then(function(data) {
            $('#loadingModal').modal('hide');
            $scope.setNewTablesData(data);
            Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save');
         }, function(error) {
            $('#loadingModal').modal('hide');
        });
        
    }

    $scope.cancelEditSmartSyncSettings = function() {
        setSyncSettingData();
        $scope.smartSyncConfiguration=angular.copy( provisioningBackupConfiguration);
        //$scope.$digest();
        
    }
    $scope.cancelEditSmartProvisioningSettings = function() {
        $scope.smartProvisioningConfiguration=angular.copy( provisioningBackupConfiguration);
    }
    $scope.cancelEditBasicProvisioningSettings = function() {
        $scope.basicProvisioningConfiguration=angular.copy( provisioningBackupConfiguration);
        $scope.useKeyAndSecret=provisioningBackupConfiguration.accessToken==null;
        $scope.form.$setPristine(); 
    }
    
    $scope.editBasicProvisioningSettings = function() {
        $scope.editSettings($scope.basicProvisioningConfiguration,0);
    }
    $scope.editSmartProvisioningSettings = function() {
        $scope.editSettings($scope.smartProvisioningConfiguration,1);
        
    }
    $scope.editSmartSyncSettings = function() {
        angular.forEach($scope.autoSyncOptionsDetails,function(item){ 
            if(item.option == $scope.smartSyncConfiguration.autoSyncSetting) {  
                $scope.smartSyncConfiguration.autoSyncTimeValue= item.detail;
                } 
            });
        $scope.smartSyncConfiguration.scheduledAutoSyncTime=null;
        $scope.editSettings($scope.smartSyncConfiguration,2);
        
    }
  
    var setBasicInSmartProvisioning = function() {
        $scope.smartProvisioningConfiguration.appKey=angular.copy(provisioningBackupConfiguration.appKey);
        $scope.smartProvisioningConfiguration.appSecret=angular.copy(provisioningBackupConfiguration.appSecret);
        $scope.smartProvisioningConfiguration.accessToken=angular.copy(provisioningBackupConfiguration.accessToken);
       // 
    }
    var setBasicInSmartSync = function() {
        $scope.smartSyncConfiguration.appKey=angular.copy(provisioningBackupConfiguration.appKey);
        $scope.smartSyncConfiguration.appSecret=angular.copy(provisioningBackupConfiguration.appSecret);
        $scope.smartSyncConfiguration.accessToken=angular.copy(provisioningBackupConfiguration.accessToken);
       // 
    }
    
    var setSmartPartsInBasic = function() {
        $scope.basicProvisioningConfiguration.adPreferredAttribute=angular.copy(provisioningBackupConfiguration.adPreferredAttribute);
//        $scope.basicProvisioningConfiguration.groupAssignSetting=angular.copy(provisioningBackupConfiguration.groupAssignSetting);
//        $scope.basicProvisioningConfiguration.accountUnssignSetting=angular.copy(provisioningBackupConfiguration.accountUnssignSetting);
//        $scope.basicProvisioningConfiguration.accountDeleteSetting=angular.copy(provisioningBackupConfiguration.accountDeleteSetting);
       // 
    }
    $scope.editSettings = function (editedConfiguration,typeOfEdit) {
        DropboxProvisioningService.provisioningConfiguration.updateProvisioningConfiguration({
            companyId : companyId,
            appId : appId
        },editedConfiguration).$promise.then(function(data) {
             provisioningBackupConfiguration = angular.copy(data);
            if(data.accessToken!=null) {
                $scope.useKeyAndSecret=false;
            }
            if(typeOfEdit==0) {
                setBasicInSmartProvisioning();
                setBasicInSmartSync();
               
            } else if(typeOfEdit==1){
                setSmartPartsInBasic();
                $scope.smartSyncConfiguration.adPreferredAttribute=angular.copy(provisioningBackupConfiguration.adPreferredAttribute);
//                $scope.smartSyncConfiguration.groupAssignSetting=angular.copy(provisioningBackupConfiguration.groupAssignSetting);
//                $scope.smartSyncConfiguration.accountUnssignSetting=angular.copy(provisioningBackupConfiguration.accountUnssignSetting);
//                $scope.smartSyncConfiguration.accountDeleteSetting=angular.copy(provisioningBackupConfiguration.accountDeleteSetting);
               
            } else {
                $scope.smartSyncConfiguration.autoSyncSetting=angular.copy(provisioningBackupConfiguration.autoSyncSetting);
                $scope.smartSyncConfiguration.autoSyncTimeValue=angular.copy(provisioningBackupConfiguration.autoSyncTimeValue);
                $scope.smartSyncConfiguration.scheduledAutoSyncTime=angular.copy(provisioningBackupConfiguration.scheduledAutoSyncTime);
                
                $scope.smartProvisioningConfiguration.autoSyncSetting=angular.copy(provisioningBackupConfiguration.autoSyncSetting);
                $scope.basicProvisioningConfiguration.autoSyncSetting=angular.copy(provisioningBackupConfiguration.autoSyncSetting);
            }
            Alert('success', 'dropbox_provisioning.configuration_save');
        });
    }

    $scope.changeConnectionWay= function() {
            if($scope.useKeyAndSecret) {
                $scope.basicProvisioningConfiguration.accessToken=null;
            } else {
                $scope.basicProvisioningConfiguration.appKey=null;
                $scope.basicProvisioningConfiguration.appSecret=null;
            }
    }
    
    $scope.changeAutoSyncSetting = function(newValue) {
        angular.forEach($scope.autoSyncOptionsDetails,function(item){ item.detail = null; });
        $scope.smartSyncConfiguration.autoSyncSetting =newValue;
    }
    
    $scope.changeAdAttributeSetting= function(newValue) {
        $scope.smartProvisioningConfiguration.adPreferredAttribute=newValue;
    }
    
    $scope.changeGroupAssignSetting= function(newValue) {
        $scope.smartProvisioningConfiguration.groupAssignSetting=newValue;
    }
    $scope.changeAccountDeletedSetting= function(newValue) {
        $scope.smartProvisioningConfiguration.accountDeletedSetting=newValue;
    }
    $scope.changeAccountUnassignSetting= function(newValue) {
        $scope.smartProvisioningConfiguration.accountUnassignSetting=newValue;
    }
   
    $scope.listDropboxGroups= function() {
        DropboxProvisioningService.dropboxSync.get({
            companyId : companyId,
            appId : appId
        }).$promise.then(function(data) {
            $scope.setNewTablesData(data);
        });
    }
    $scope.setNewTablesData = setNewTablesData;
    function setNewTablesData(data) {
        $scope.dropboxSyncMappings=data.syncMappings;
        $scope.dropboxProvisioningMappings=data.provisioningMappings;
        $scope.saaspassGroups=data.companySaaspassGroups;
        $scope.displayedDropboxSyncMappings = [].concat($scope.dropboxSyncMappings);
        $scope.displayedDropboxProvisioningMappings = [].concat($scope.dropboxProvisioningMappings);
        
       $scope.showAutomap= $scope.displayedDropboxSyncMappings.findIndex(obj => obj.saaspassGroup==null)!=-1;
    }
    
    $scope.openProvSettings = function(groupMapping) {
        $uibModal
            .open({
                component: 'dropboxProvisioningSettings',
                resolve: {groupMapping: () => groupMapping},
            }).result
            .then(() => {
                Alert('success', 'dropbox_provisioning.sync_settings_modal.successful_save');
            });
    }
    
    $scope.openSyncSettings = (groupMapping) => {
        $uibModal.open({
            component: 'dropboxSyncSettings',
            resolve: {groupMapping: () => groupMapping},
        }).result.then((savedGroupMapping) => {
            Object.assign(groupMapping, savedGroupMapping);
            Alert('success', 'dropbox_provisioning.sync_settings_modal.successful_save');
        });
    }
    
    $scope.openSyncMap = (groupMapping) => {
        $uibModal.open({
            component: 'dropboxSyncMapping',
            resolve: {
                applicationName: () => $scope.application.applicationName,
                dropboxProvisioningMappings: () => $scope.dropboxProvisioningMappings,
                groupMapping: () => groupMapping,
                saaspassGroups: () => $scope.saaspassGroups,
            },
        }).result.then((data) => {
            if (data.createProvMapping) {
                Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save2');
            } else {
                Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save');
            }
            $scope.setNewTablesData(data.response);
        });
    }
    
    $scope.openProvMap = function(theMapping) {
        $uibModal
            .open({
                component: 'dropboxProvisioningMapping',
                resolve: {
                    groupMapping: () => theMapping,
                    saaspassGroups: () => $scope.saaspassGroups,
                    applicationName: () => $scope.application.applicationName,
                    dropboxProvMappings: () => $scope.dropboxProvisioningMappings,
                    dropboxSyncMappings: () => $scope.displayedDropboxSyncMappings,
                },
            }).result
            .then((data) => {
                $scope.setNewTablesData(data);
                Alert('success', 'dropbox_provisioning.prov_map_modal.successful_save');
            });
    }
    
    $scope. removeMapping= function(theMapping) {
        $uibModal
            .open({component: 'confirmRemoveDropboxProvisioningMapping'}).result
            .then(() => {
        DropboxProvisioningService.groupMapping.remove({
            companyId : companyId,
            appId : appId
        },theMapping).$promise.then(function(data) {
            $scope.setNewTablesData(data);
            Alert('success', 'dropbox_provisioning.remove_mapping.successful_remove');
        })
        });
    }

    $scope.displayExportSpinner = false;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning.controller.js